import { render, staticRenderFns } from "./update-user-details-form.html?vue&type=template&id=d24c9c86&scoped=true&external"
import script from "./update-user-details-form.js?vue&type=script&lang=js&external"
export * from "./update-user-details-form.js?vue&type=script&lang=js&external"
import style0 from "./update-user-details-form.scss?vue&type=style&index=0&id=d24c9c86&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24c9c86",
  null
  
)

export default component.exports